/** Base class for every error raised by the application so callers can distinguish domain errors from bugs. */
export class SyncPortError extends Error {
  constructor(message: string) {
    super(message);
    this.name = new.target.name;
  }
}

export class ProtocolError extends SyncPortError {}
